import enUS from '@kangc/v-md-editor/lib/lang/en-US'
import esES from '@kangc/v-md-editor/lib/lang/es-ES'
import frFR from '@kangc/v-md-editor/lib/lang/fr-FR'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.config.globalProperties.$vMdEditorLang = 'en-US'
    app.config.globalProperties.$vMdEditorLangConfig = {
      'en-US': enUS,
      'es-ES': esES,
      'fr-FR': frFR,
    }
  },
}
